import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-importExcel",
  "use": "icon-importExcel-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-importExcel\"><defs><style type=\"text/css\"></style></defs><path d=\"M766.84 101.64H322.7a65.14 65.14 0 0 0-65.07 65.07V296h57.22V166.71a7.86 7.86 0 0 1 7.85-7.85h444.14a7.86 7.86 0 0 1 7.85 7.85v690.58a7.86 7.86 0 0 1-7.85 7.85H322.7a7.86 7.86 0 0 1-7.85-7.85V750.76h-57.22v106.53a65.14 65.14 0 0 0 65.07 65.07h444.14a65.14 65.14 0 0 0 65.07-65.07V166.71a65.14 65.14 0 0 0-65.07-65.07z\" p-id=\"2072\" /><path d=\"M400.91 684.93l35.31 45.03 248.33-194.78L437.5 316.99l-37.88 42.88 164.63 145.39H247.59v57.22h309.44L400.91 684.93z\" p-id=\"2073\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/importExcel.svg
// module id = AtEP
// module chunks = 118